import {FeatureFlag, useFeatureFlag} from '@/features/feature-flags';
import {useTrustTypeStrategy} from '@/features/trust-accounts/providers';

/** Payouts also require the `payouts_tab` flag on top of the trust type's own support for it. */
export function useShowsPayoutsTab(): boolean {
  const {showsPayoutsTab} = useTrustTypeStrategy();
  const payoutsTabFlagEnabled = useFeatureFlag(FeatureFlag.PAYOUTS_TAB);
  return showsPayoutsTab && payoutsTabFlagEnabled;
}
